import React from 'react';
import { connect } from 'react-redux';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import CheckIcon from '@mui/icons-material/CheckRounded';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const EditHistoryOptionSelect = (props) => {
    const { classes, editHistoryEnabled, setEditHistoryEnabled } = props;

    return (
        <>
            <MenuItem
                onClick={() => setEditHistoryEnabled(true)}
                selected={editHistoryEnabled}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: editHistoryEnabled ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    ENABLED
                </ListItemText>
            </MenuItem>
            <MenuItem
                onClick={() => setEditHistoryEnabled(false)}
                selected={!editHistoryEnabled}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: !editHistoryEnabled ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    DISABLED
                </ListItemText>
            </MenuItem>
        </>
    );
};

const mapStateToProps = (state) => {
    const { editHistoryEnabled } = state.create;
    return { editHistoryEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const setEditHistoryEnabled = (enabled) => dispatch(createActions.setEditHistoryEnabled(enabled));
    return { setEditHistoryEnabled }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditHistoryOptionSelect, styles));
